import React from "react";
import "./CountryList.css";
import Header from "../header/Header";
import EditImage from "../../assets/Country-logo1.svg";
import AddImage from "../../assets/country-logo2.svg";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import Sidebar from "../Sidebar/Sidebar";
import { hasPermission } from "../GlobalFunction";

const CountryList = () => {
  const navigate = useNavigate();
  const canUpdate = hasPermission("country_list", "update");
  const canCreate = hasPermission("country_list", "create");
  return (
    <>
      <div className="main-box">
        <Sidebar activeId={2} />
        <main className="main-content">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100vh",
            }}
          >
            <Header title="Country Management" />
            <div
              style={{
                flex: 1,
                padding: "1rem",
                display: "flex",
                boxSizing: "border-box",
                alignItems: "center",
                justifyContent: "center",
                overflowY: "auto",
              }}
            >
              <div className="box-container">
                {canUpdate && (
                  <div className="countryBox">
                    <div className="box-detail">
                      <p className="box-title">
                        Edit Fields for Existing Country
                      </p>
                      <p className="box-desc">
                        Customize the onboarding form for a specific country. Add,
                        edit, or remove fields based on local requirements. Select
                        a country to get started.
                      </p>
                      <Button
                        type="primary"
                        onClick={() => navigate("/EditCountry")}
                      >
                        Edit Fields
                      </Button>
                    </div>
                    <img src={EditImage} alt="Edit-country" />
                  </div>
                )}
                {canCreate && (
                  <div className="countryBox">
                    <div className="box-detail">
                      <p className="box-title">Add a New Country</p>
                      <p className="box-desc">
                        Set up a new country in the onboarding form. Add default
                        fields and configure country-specific inputs to ensure
                        compliance and smooth onboarding.
                      </p>
                      <Button
                        type="primary"
                        onClick={() => navigate("/AddCountry")}
                      >
                        Add Country
                      </Button>
                    </div>
                    <img src={AddImage} alt="Edit-country" />
                  </div>
                )}
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default CountryList;
